import React, {memo} from 'react';
import {FormattedMessage} from 'react-intl';

import Block from '../block';
import IntlStringHtml from '../intl-string-html';
import RatioImage from '../ratio-image';
import StripedTeaser from '../striped-teaser';

export default memo(
	/**
	 * @param {{
	 *   image?: null | import("../../../tmp/graphql-types").RatioImageFragment,
	 *   text?: null | import("../../../tmp/graphql-types").IntlStringHtmlFragment,
	 *   meta: import("../../page-metadata").PageMetadata,
	 *   hashState: number,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function Intro({image, text, meta, hashState}) {
		return (
			<Block paddingX={true} background={true}>
				<StripedTeaser
					hashState={hashState}
					headline={(<FormattedMessage id={meta.titleI18nId} />)}
					url={undefined}
					left={image && (<RatioImage {...image} />)}
				>
					{text && (
						<IntlStringHtml {...text} />
					)}
				</StripedTeaser>
			</Block>
		);
	}
);
